import { convertNumber } from "utils"
import { BalanceSheetReportType } from "../types"
import { ImArrowDown, ImArrowUp } from "react-icons/im"

type ItemTotalProps = { item: BalanceSheetReportType }

export const TableTotalCOA = ({ item }: ItemTotalProps) => {
  const isNormalFontWeight = [3].includes(item.header_level)

  return (
    <tr
      key={item.coa_id + "total"}

    >
      <td>
        <span
          style={{ marginLeft: (item.coa_level - 1) * 24 }}
          className={isNormalFontWeight ? "font-normal" : "font-bold"}>
          {`TOTAL ${item.coa_name}`}
        </span>
      </td>

      {item.actual?.map((actual, index) => (
        <td
          key={actual + index}
          className={`text-right 
          ${isNormalFontWeight ? "font-normal" : "font-bold"}
          `}>
          {convertNumber(Math.abs(actual)).intoCurrency}
        </td>
      ))}
      {item.budget?.map((budget, index) => (
        <td
          key={budget + index}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          {convertNumber(Math.abs(budget)).intoCurrency}
        </td>
      ))}
      {item.variance?.map((variance, index) => (
        <td
          key={variance + index}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          <div className="flex items-center justify-end gap-2">
            {convertNumber(Math.abs(variance)).intoCurrency}
            {variance > 0 ? (
              <ImArrowDown className="text-green-500" />
            ) : variance < 0 ? (
              <ImArrowUp className="text-red-500" />
            ) : null}
          </div>
        </td>
      ))}
      {item.percent_variance?.map((percentVariance, index) => (
        <td
          key={percentVariance + index}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          {`${convertNumber(Math.abs(percentVariance)).intoNormalAmount} %`}
        </td>
      ))}
    </tr>
  )
}
